"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
function findSafeFrameAPI(windowObject) {
    const window_ = windowObject || window;
    try {
        if (window_['$sf']) {
            return window_['$sf']['ext'];
        }
        else if (window_ !== window.top) {
            return findSafeFrameAPI(window_.parent);
        }
    }
    catch (ignored) { }
    return null;
}
function isAvailable() {
    if (typeof window !== 'undefined') {
        return !!findSafeFrameAPI();
    }
    else {
        return false;
    }
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=safeframe-pixel.js.map